<div class="tw-flex tw-items-center tw-justify-between tw-w-full">
  <ng-content select="[issDrawerFooterExtras]"/>
  <div class="tw-w-full tw-flex tw-items-center tw-gap-[8px] tw-justify-end">
    <ng-content/>
  </div>
</div>
